// extracted by mini-css-extract-plugin
export default {"bonus":"Bonus_bonus__Bf+vi"};